__turbopack_context__.v({
  "desc": "PlasmicNewsItem-module__3dEqUG__desc",
  "download": "PlasmicNewsItem-module__3dEqUG__download",
  "excerptDate": "PlasmicNewsItem-module__3dEqUG__excerptDate",
  "links": "PlasmicNewsItem-module__3dEqUG__links",
  "newsExcerptsItem": "PlasmicNewsItem-module__3dEqUG__newsExcerptsItem",
  "title2": "PlasmicNewsItem-module__3dEqUG__title2",
  "top": "PlasmicNewsItem-module__3dEqUG__top",
});
